import React, { useState, useEffect } from 'react'
import Tabla from '../../components/Tabla'
import useUser from '../../hooks/useUser'
import { useNavigate, Link  } from 'react-router-dom'
import { getPermisosEnPagina, getBasePath, getAuth } from '../../Utils'
import SinPermisos from '../SinPermisos'
import axios from "axios"
import Swal from 'sweetalert2'

const columns = [
    {
        name: 'Producto',
        selector: row => row.producto,
        sortable: true,
    },
    {
        name: 'Cantidad',
        selector: row => row.cantidad,
        sortable: true,
    },
    {
        name: 'Caducidad',
        selector: row => row.fechaCaducidad,
        sortable: true,
    },
    {
        name: '',
        selector: row => row.ver,
        sortable: false,
        width: "75px",
        margin: "0"
    },
    {
        name: '',
        selector: row => row.editar,
        sortable: false,
        width: "75px",
        margin: "0"
    },
    {
        name: '',
        selector: row => row.borar,
        sortable: false,
        width: "75px",
        margin: "0"
    }
];

const eliminarInventario = (id) => {
    Swal.fire({
        title: "Selecciona cantidad a borrar",
        html: '<input type="number" id="cantidadBorrado">',
        showCancelButton: true,
        showAcceptButton: true,
    }).then(async (e) => {
        if(e.isConfirmed) {
            const cantBorrado = document.querySelector('#cantidadBorrado').value
            await axios.get(`${getBasePath()}/inventarios/${id}_${cantBorrado}`, getAuth());
        }
    })
}

const Inventario = () => {
    const {isLogged, permisosUsuario} = useUser();
    const navigate = useNavigate();
    const permisos = getPermisosEnPagina(permisosUsuario, 'Inventario')
    const [data, setData] = useState([])

    const cargarData = async () => {
        const {data: inventario} = await axios.get(`${getBasePath()}/inventarios`, getAuth());
        const {data: productos} = await axios.get(`${getBasePath()}/productos`, getAuth());
        console.error(inventario)
        inventario.forEach(el =>  {
            el.producto = productos.data.find(pro => pro.id == el.productoId).nombre
            if(permisos.editar) 
                el.editar = (<div><Link to={`/inventarioform/editar/${el.productoId}&${el.cantidad}&${el.fechaCaducidad}`} style={{ color:"black",marginRight:"4px"}} className="btn cur-p btn-outline-primary"><i className="ti ti-pencil"></i></Link></div>)
            if(permisos.borrar) 
                el.borar = (<div><Link to={`/inventario`} onClick={() => eliminarInventario(el.productoId)} style={{ color:"black",marginRight:"4px"}} className="btn cur-p btn-outline-primary"><i className="ti ti-trash"></i></Link></div>)
            el.ver = (<div><Link to={`/inventarioform/ver/${el.productoId}&${el.cantidad}&${el.fechaCaducidad}`} style={{ color:"black",marginRight:"4px"}} className="btn cur-p btn-outline-primary"><i className="ti ti-eye"></i></Link></div>)
        })
        setData(inventario)
    }

    useEffect(() => {
        cargarData()
    },[])

    useEffect(() => {
        if (!isLogged) { navigate("/login"); }
    }, [isLogged]);

    return isLogged && permisos.ver ? (<div>
        <div className="bgc-white p-20 bd" style={{ marginBottom: "10px" }}>
            <h6 className="c-grey-900">Inventario</h6>
            { permisos.crear &&
                <div className="mT-30">
                    <Link className="btn btn-success btn-color" to="/inventarioform/nuevo">Nuevo</Link>
                </div>
            }
        </div>
        <Tabla columns={columns} data={data} selectableRows />
    </div>) : (<SinPermisos/>)
}
export default Inventario